export default {
  logo: {
    id: 'product_page_google_fi_popup_logo_alt',
    defaultMessage: 'Google Fi',
  },
  popupTitle: {
    id: 'product_page_google_fi_popup_title',
    defaultMessage: 'Get an exclusive Google Fi promo code with this phone.',
  },
  popupBody: {
    id: 'product_page_google_fi_popup_body',
    defaultMessage:
      'Pair this phone with a Google Fi plan and get exclusive pricing. Apply the code at checkout on the Google Fi site. {link, html}',
  },
  termsLink: {
    id: 'product_page_google_fi_popup_terms_link',
    defaultMessage: 'Terms Apply',
  },
  stepsTitle: {
    id: 'product_page_google_fi_popup_steps_title',
    defaultMessage: 'How to activate your savings',
  },
  step1: {
    id: 'product_page_google_fi_popup_step1',
    defaultMessage: 'Buy any unlocked phone on Back Market.',
  },
  step2: {
    id: 'product_page_google_fi_popup_step2',
    defaultMessage: 'Get the promo code in your confirmation email.',
  },
  step3: {
    id: 'product_page_google_fi_popup_step3',
    defaultMessage: 'Use your code when subscribing to a Google Fi plan.',
  },
  closeButtonLabel: {
    id: 'product_page_google_fi_popup_close_button_label',
    defaultMessage: 'Close "Google Fi" popup',
  },
}
